import React from 'react';
import { GoalIndication } from './goal-indication/GoalIndication';

export const GoalIndicationScreen: React.FC<{}> = () => {
    return <GoalIndication />;
};
